module.exports = __webpack_public_path__ + "static/img/thumb.d61b09b7.png";